import React from 'react'
import Typist from 'react-typist'
import Button from '../Button/Button'
import Divider from '../Divider/Divider'
import withSizes from 'react-sizes'
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody,
} from 'react-accessible-accordion'
import styles from './Intro.module.css'

const Intro = props => {
  function createBackground() {
    if (!props.isMobile) {
      return (
        <div className={styles.videoWrapper}>
          <video id="background-video" preload="none" loop muted autoPlay>
            <source src="/domsysbg.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      )
    }
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.overlay} />
      {createBackground()}
      <div className={styles.gradientDivider} />
      <div className={styles.intro}>
        <div className={styles.text}>
          <h1>
            <Typist>
              <Typist.Delay ms={500} />
              {props.heading}
            </Typist>
          </h1>
          <Divider />
          <p>{props.body}</p>
          <Button title="Learn More" link="/about/" />
        </div>
        <div className={styles.solutions}>
          <h2>Qualifications</h2>
          <Divider />
          <Accordion>
            {props.qualifications.map(item => (
              <AccordionItem key={item.qualification}>
                <AccordionItemTitle>{item.qualification}</AccordionItemTitle>
                <AccordionItemBody>{item.notes}</AccordionItemBody>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  )
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 700,
})

export default withSizes(mapSizesToProps)(Intro)



// WEBPACK FOOTER //
// ./src/components/Intro/Intro.js